import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, API_ENDPOINTS, AI_DETECTION_ENDPOINTS, CATEGORY } from '@core';
import {
  DetectionTaskStarted,
  DoorsWindowsPointsResponse,
  DoorsWindowsPricingDrawerResponse,
  DoorsWindowsPricingDrawerSaveRequest,
  DoorsWindowsPricingDrawerSaveResponse,
  DoorsWindowsTaskStatusResponse,
  DoorsWindowsUpdateContourPayload,
  DoorsWindowsUpdateContourResponse,
} from '@core/models/project.models';
import { ApiResponse } from '@core/models/api.models';

@Injectable({ providedIn: 'root' })
export class DoorsWindowsApiService {
  private readonly api = inject(ApiService);

  triggerPreProcess(projectId: number, scale?: string): Observable<ApiResponse<DetectionTaskStarted>> {
    return this.api.post<DetectionTaskStarted>(AI_DETECTION_ENDPOINTS[CATEGORY.DOORS_WINDOWS.numericId].preProcess!, {
      project_id: projectId,
      file_type_id: CATEGORY.DOORS_WINDOWS.numericId,
      ...(scale ? { scale } : {}),
    });
  }

  pollStatus(taskId: string): Observable<DoorsWindowsTaskStatusResponse> {
    return this.api.get<DoorsWindowsTaskStatusResponse>(
      `${AI_DETECTION_ENDPOINTS[CATEGORY.DOORS_WINDOWS.numericId].taskStatus}/${taskId}`,
    ) as unknown as Observable<DoorsWindowsTaskStatusResponse>;
  }

  getPoints(projectId: number): Observable<ApiResponse<DoorsWindowsPointsResponse>> {
    return this.api.get<DoorsWindowsPointsResponse>(
      API_ENDPOINTS.project.getDoorsWindowsPoints(projectId),
    );
  }

  updateContourPoints(payload: DoorsWindowsUpdateContourPayload): Observable<ApiResponse<DoorsWindowsUpdateContourResponse>> {
    return this.api.post<DoorsWindowsUpdateContourResponse>(
      API_ENDPOINTS.project.updateContourPointsDoorsWindows,
      payload,
    );
  }

  getPricingDrawer(projectId: number, floorName: string): Observable<ApiResponse<DoorsWindowsPricingDrawerResponse>> {
    return this.api.get<DoorsWindowsPricingDrawerResponse>(
      `${API_ENDPOINTS.project.pricingDrawerDoorsWindows(projectId)}?floorName=${encodeURIComponent(floorName)}`,
    );
  }

  savePricingDrawer(
    projectId: number,
    payload: DoorsWindowsPricingDrawerSaveRequest,
  ): Observable<ApiResponse<DoorsWindowsPricingDrawerSaveResponse>> {
    return this.api.post<DoorsWindowsPricingDrawerSaveResponse>(
      API_ENDPOINTS.project.pricingDrawerDoorsWindows(projectId),
      payload,
    );
  }

}
